import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

/**
 * i18n configuration with lazy loading via HTTP backend.
 * Translations are loaded on-demand from public/locales/{lng}.json
 * Only the active language is loaded, reducing initial bundle size.
 */
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'fr', 'nl', 'cs'],
    // Strip region codes (de-DE -> de, fr-FR -> fr) to match our translation files
    load: 'languageOnly',
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
    },
  });

export default i18n;
